/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import qs from 'qs';
import { Button, Avatar, ConfigProvider, Breadcrumb, Input, Divider, Modal } from 'antd';
import { withQuery } from '@/utils';
import * as actions from '@/models/products/actions';
import * as selectors from '@/models/products/selectors';
import { getTenantById } from '@/models/tenants/services';
import styles from './products.module.scss';
import ProductInfoDialog from '@/components/dialogs/ProductInfoDialog';
import PageableTable from '@/components/PageableTable';
import * as apis from '@/apis'
const { Search } = Input;

function updateHistoryProduct(id) {
  let productHis = []
  let productStorage = localStorage.getItem(`${process.env.APP_MODE}_add_product`)
  try {
    productHis = JSON.parse(productStorage) || []
  } catch (error) { }

  if (productHis.length) {
    productHis = productHis.filter(item => item._id != id);
  }
  localStorage.setItem(`${process.env.APP_MODE}_add_product`, JSON.stringify(productHis))
}

function getColumns({ showInfoDialog, Category, onSuccess }) {
  const dispatch = useDispatch();
  const isTenantMode = process.env.APP_MODE === 'tenant';
  return [
    {
      key: '_id',
      title: '',
      dataIndex: '_id',
      width: 30,
      render: (text, record, idx) => (
        <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
      ),
    },
    {
      title: '产品封面图',
      dataIndex: 'cover',
      width: 120,
      render: (val) => (
        <Avatar shape="square" size={56} className={styles.image} src={val} />
      ),
    },
    {
      title: '产品名',
      dataIndex: 'name',
      width: 120,
    },
    {
      title: '产品分类',
      dataIndex: 'category',
      width: 120,
      render: (text, record, idx) => (
        <div>
          {Category?.map(ele => { return (ele._id === record.category ? ele.name : "") })}
        </div>
      ),
    },
    {
      title: '摘要信息',
      dataIndex: 'desc',
      render: (val) => {
        if (isTenantMode) {
          return '-';
        }

        return val;
      },
    },
    {
      title: '添加日期',
      dataIndex: 'createdAt',
      width: 160,
      render: (val) => (
        <div style={{ whiteSpace: 'nowrap' }}>
          {dayjs(val).format('YYYY-MM-DD HH:mm:ss')}
        </div>
      ),
    },
    {
      title: '操作',
      fixed: 'right',
      width: 120,
      render: (item) => {
        return (
          <div style={{ whiteSpace: 'nowrap' }}>
            <a onClick={() => {
              Modal.confirm({
                title: '确认删除',
                content: `确定要删除产品"${item.name}"吗？`,
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                  updateHistoryProduct(item._id)
                  dispatch(actions.setActiveState(item._id, false, onSuccess))
                }
              });
            }}>删除</a>
            <Divider type="vertical" />
            <a
              onClick={showInfoDialog(
                `编辑产品 - ${item.name}`,
                item.tenant_id,
                item._id
              )}
            >
              编辑
            </a>
          </div>
        );
      },
    },
  ];
}

function Products(props) {
  const dispatch = useDispatch();
  const { query, history, match, location } = props;
  const tenantId = props.tenantId || match.params.id;
  const [tenant, setTenant] = useState(null);
  const [Category, setCategory] = useState([]);
  const [queryText, setQueryText] = useState("");

  const prevQuery = usePrevious(query);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const loading = useSelector(selectors.loadingSelector);
  const total = useSelector(selectors.totalSelector);
  const products = useSelector(selectors.entriesSelectors);
  const pagination = {
    showQuickJumper: true,
    total: total,
  };

  const fetch = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setQueryParams(params)
    dispatch(actions.fetchList(tenantId, params));
  }, []);

  const fetchCategory = async () => {
    const result = await apis.findRecommend()
    setCategory(result || [])
  }
  const showInfoDialog = useCallback(
    (title, tenantId, id) => () => {
      updateHistoryProduct(id)
      dispatch(
        actions.showInfoDialog({
          title,
          tenant_id: tenantId,
          id,
          onSuccess
        })
      );
    },
    []
  );
  const onSearch = useCallback((keyword) => {
    query.keyword = keyword
    fetch(query);
  })
  const onChange = useCallback((e) => {
    setQueryText(e.target.value)
  })
  const handleTableChange = useCallback(
    (params) => {
      window.scrollTop = 0;
      const nextQuery = {
        ...query,
        ...queryParams,
        ...params,
      };
      fetch(nextQuery)
    },
    [location, queryParams]
  );
  const onSuccess = useCallback(() => {
    query.keyword = queryText
    fetch(query);
    window.parent.postMessage({ dataType: 'addProductSuccess' })
  });
  const exportProduct = useCallback(() => {
    query.keyword = queryText
    const downloadUrl = apis.getProductDumpUrl(query);
    window.open(downloadUrl)
  });
  const columns = getColumns({ showInfoDialog, Category, onSuccess });

  useMount(() => {
    fetch(query);
    fetchCategory()
  });

  useEffect(() => {
    if (/^\/enterprises\//.test(location.pathname)) {
      getTenantById(tenantId).then((result) => setTenant(result));
    }
  }, [tenantId]);

  // useUpdateEffect(() => {
  //   if (prevQuery.offset !== query.offset) {
  //     window.scrollTop = 0;
  //     fetch(query);
  //   }
  // });

  const customizeRenderEmpty = () => (
    <div className={styles.emptyTips}>
      <img className={styles.img} src={process.env.PUBLIC_URL + '/empty.svg'}></img>
      <div className={styles.text}>
        <div>还未添加任何产品信息， 赶紧去添加吧 </div>
        <Button
          onClick={showInfoDialog('添加产品', tenantId)}
          type="primary"
          size="small"
          className={styles.createBtn}
        >
          添加
        </Button>
        <div>吧 ^_^</div>
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          {tenant && (
            <Breadcrumb.Item>
              {tenant.short_name || tenant.name}
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item>产品管理</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <Search
            placeholder="请输入关键词"
            allowClear
            enterButton
            value={queryText}
            onChange={onChange}
            style={{ width: 300, marginRight: 10 }}
            onSearch={onSearch}
          />
          <Button onClick={showInfoDialog('添加产品', tenantId)} style={{ marginRight: 10 }}>添加产品</Button>
          <Button type="link" onClick={exportProduct} >下载</Button>
        </div>
      </div>

      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <PageableTable
          className={styles.table}
          columns={columns}
          dataSource={products.toJS()}
          pagination={pagination}
          total={total}
          limit={+limit}
          offset={+offset}
          onChange={handleTableChange}
          loading={loading}
        />
      </ConfigProvider>
      <ProductInfoDialog type="staff" />
    </div>
  );
}

export default withQuery(Products);
